import * as Yup from 'yup';

export default Yup.object().shape({
    phone: Yup.string().required('El usuario es obligatorio'),
    password: Yup.string().required('La contraseña es obligatoria'),
});
